import { render } from "./ManualDataBox.vue?vue&type=template&id=9afd5b62"
import script from "./ManualDataBox.vue?vue&type=script&lang=js"
export * from "./ManualDataBox.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__